import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServiceInterface } from '../interfaces/service.interface';
import { Menu } from '../models/menu.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})

export class MenuService implements ServiceInterface {
  API_BASE_URL: string;

  constructor(
    private _httpService: HttpService,
  ) {
    this.API_BASE_URL = environment.API;
  }

  loadAll(payload?: any): Observable<Menu[]> {
    const url = `${this.API_BASE_URL}/menus`;

    return this._httpService.get(url, payload).pipe(map((result: any) => result));
  }

  loadByUser(payload?: any): Observable<Menu[]> {
    const url = `${this.API_BASE_URL}/acl`;

    return this._httpService.get(url, payload).pipe(map((result: any) => result));
  }

  loadOne(id: number): Observable<Menu> {
    const url = `${this.API_BASE_URL}/menus/${id}`;

    return this._httpService.get(url).pipe(map((result: any) => result.data));
  }

  create(payload: any): Observable<Menu> {
    const url = `${this.API_BASE_URL}/menus`;

    return this._httpService.post(url, payload).pipe(map((result: any) => result.data));
  }

  update(id: number, payload: any): Observable<Menu> {
    const url = `${this.API_BASE_URL}/menus/${id}`;

    return this._httpService.put(url, payload).pipe(map((result: any) => result.data));
  }

  destroy(id: number): Observable<Menu> {
    const url = `${this.API_BASE_URL}/menus/${id}`;

    return this._httpService.delete(url).pipe(map((result: any) => result.data));
  }

  loadMessagesBadge(payload?: any): Observable<Menu[]> {
    const url = `${this.API_BASE_URL}/acl/unread`;

    return this._httpService.get(url, payload).pipe(map((result: any) => result));
  }
}
